import { c as _c } from "react/compiler-runtime";
/** The glyph standing for a series in a legend or a reading row. */
export type ChartLegendMarkKind = 'dot' | 'line' | 'line-soft' | 'line-dashed' | 'line-thick' | 'triangle-down' | 'triangle-up' | 'diamond';

/**
 * Drawn in `currentColor`, so a legend item carries its colour as a text
 * class and the mark follows — no colour literal anywhere in the legend.
 */
export const ChartLegendMark = t0 => {
  const $ = _c(8);
  const {
    kind
  } = t0;
  switch (kind) {
    case "dot":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><circle cx="5" cy="5" r="4.5" fill="currentColor" /></svg>;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "triangle-down":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="10" height="9" viewBox="0 0 10 9" aria-hidden="true"><path d="M0 0h10L5 9z" fill="currentColor" /></svg>;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "triangle-up":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="10" height="9" viewBox="0 0 10 9" aria-hidden="true"><path d="M0 9h10L5 0z" fill="currentColor" /></svg>;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "diamond":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 0l5 5-5 5-5-5z" fill="currentColor" /></svg>;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "line-thick":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="24" height="10" viewBox="0 0 24 10" aria-hidden="true"><path d="M1 5h22" stroke="currentColor" strokeWidth="4" strokeLinecap="round" /></svg>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "line-dashed":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="22" height="10" viewBox="0 0 22 10" aria-hidden="true"><path d="M0 5h22" stroke="currentColor" strokeWidth="1.5" strokeDasharray="4 3" /></svg>;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "line-soft":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="22" height="10" viewBox="0 0 22 10" aria-hidden="true"><path d="M0 5h22" stroke="currentColor" strokeWidth="1.2" /></svg>;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "line":
    default:
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <svg width="22" height="10" viewBox="0 0 22 10" aria-hidden="true"><path d="M0 5h22" stroke="currentColor" strokeWidth="2" /></svg>;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
  }
};